import axios from "axios";

export const getLatLong = async (zipcode) => {
  return await axios.get("/api/restaurants/latlong?zipcode=" + zipcode);
};

/**
 * Reverse geocode coordinates to get city name
 * @param {number} lat - Latitude
 * @param {number} lng - Longitude
 * @returns {Promise<{city: string|null, state: string|null, formatted: string}>}
 */
export const reverseGeocode = async (lat, lng) => {
  try {
    const response = await axios.get(`/api/restaurants/reverse-geocode?lat=${lat}&lng=${lng}`);
    return response.data;
  } catch (error) {
    console.error("Error reverse geocoding:", error);
    return { city: null, state: null, formatted: null };
  }
};
